import { HhcParticipantData } from '@modules/study-insights/components/ParticipantRecluitment/shared/types/HhcParticipantData.types';
import { partnerClient } from '@modules/core/services';
import { FetchHhcParams } from '@modules/study-insights/components/ParticipantRecluitment/shared/types/participants.types';

export const fetchHhcParticipantsData = async ({
  startDate,
  endDate,
  groupKey,
}: FetchHhcParams): Promise<HhcParticipantData | undefined> => {
  return await partnerClient.get(`recruitment/helix-hosted-consent-participants`, {
    params: {
      startDate,
      endDate,
      groupKey,
    },
  });
};
